<template>
  <tr v-on-clickaway="away" class="tr-nowrap">
    <th scope="row">
      <div class="form-group">
        <input-field placeholder="Posición" :id="'index' + index" v-model="currentPosition"></input-field>
        <button @click="cambiarIndice" class="btn-success btn--text" type="button">
          <i class="fa fa-check"></i>
        </button>
      </div>
    </th>
    <td @click="clickSelectNombre">
      <div v-if="mostrarSelectNombre" class="multiselect-field">
        <multiselect
          :tooltip="modelValue.selectedItem?modelValue.selectedItem.nombre:undefined"
          :loading="isLoadingItem"
          @input="inputItem"
          @search-change="onSearchItem"
          @tag="addTagItem"
          taggable
          v-model.lazy="modelValue.selectedItem"
          label="nombre"
          :options="listaProductos"
          :preserve-search="true"
          track-by="id"
          placeholder="Escriba y seleccione..."
          selectedLabel="Seleccionado"
          selectLabel="Presiona enter para seleccionar"
          deselectLabel="Presiona enter para eliminar"
        >
          <template slot="noOptions"><span>La lista esta vacía</span></template>
          <template slot="noResult"><span>No se encontraron elementos. Considere cambiar la consulta de búsqueda.</span></template>
        </multiselect>
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.selectedItem.id')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.selectedItem.id'][0] }}</strong>
        </span>
      </div>
      <span v-else>{{ modelValue.selectedItem !== null?modelValue.selectedItem.nombre:'' }}</span>
    </td>
    <td @click="clickSelectNombre">
      <textarea-field
        maxlength="65535"
        v-model.lazy="modelValue.descripcion"
        placeholder="..."
        :id="'descripcionItem' + index"
      >
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.descripcion')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.descripcion'][0] }}</strong>
        </span>
      </textarea-field>
    </td>
    <td @click="clickSelectNombre">
      <div v-if="mostrarSelectNombre" class="multiselect-field">
        <multiselect
          :tooltip="modelValue.selectedCategoria?modelValue.selectedCategoria.nombre:undefined"
          :loading="isLoadingCategoria"
          @input="inputCategoria"
          @tag="addTagCategoria"
          @search-change="onSearchCategoria"
          taggable
          v-model.lazy="modelValue.selectedCategoria"
          label="nombre"
          :options="listaCategorias"
          :preserve-search="true"
          track-by="id"
          placeholder="Escriba y seleccione..."
          selectedLabel="Seleccionado"
          selectLabel="Presiona enter para seleccionar"
          deselectLabel="Presiona enter para eliminar"
        >
          <template slot="noOptions"><span>La lista esta vacía</span></template>
          <template slot="noResult"><span>No se encontraron elementos. Considere cambiar la consulta de búsqueda.</span></template>
          <span
            v-if="errores.hasOwnProperty('detalles.' + index + '.selectedCategoria.id')"
            class="helper-text text-danger"
            slot="helper"
          >
            <strong>{{ errores['detalles.' + index + '.selectedCategoria.id'][0] }}</strong>
          </span>
        </multiselect>
      </div>
      <span
        v-else
      >{{ modelValue.selectedCategoria !== null?modelValue.selectedCategoria.nombre:'' }}</span>
    </td>
    <td @click="clickSelectNombre">
      <label v-if="mostrarSelectNombre" :for="'esProducto' + index">
        <input
          @change="$emit('updated')"
          v-model.lazy="modelValue.tipo_item"
          value="P"
          type="radio"
          :id="'esProducto' + index"
        />
        <span>Producto</span>
      </label>
      <label v-if="mostrarSelectNombre" :for="'esServicio' + index">
        <input
          @change="$emit('updated')"
          v-model.lazy="modelValue.tipo_item"
          value="S"
          type="radio"
          :id="'esServicio' + index"
        />
        <span>Servicio</span>
      </label>
      <span v-else>{{ modelValue.tipo_item === 'P'?'Producto':'Servicio' }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        @keypress.native="$emit('changed')"
        @input="$emit('updated')"
        vMoney
        :format="decimal"
        v-model.lazy="modelValue.cantidad"
        :id="'cantidad' + index"
      >
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.cantidad')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.cantidad'][0] }}</strong>
        </span>
      </input-field>
      <span v-else>{{ decimalFormat(modelValue.cantidad) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        @keypress.native="$emit('changed')"
        @input="$emit('updated')"
        vMoney
        :format="money2"
        v-model.lazy="modelValue.precio"
        :id="'precio' + index"
      >
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.precio')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.precio'][0] }}</strong>
        </span>
      </input-field>
      <span v-else>{{ moneyFormat(modelValue.precio) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        @keypress.native="$emit('changed')"
        vMoney
        :format="money2"
        :id="'coste' + index"
        v-model.lazy="modelValue.coste"
      >
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.coste')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.coste'][0] }}</strong>
        </span>
      </input-field>
      <span v-else>{{ moneyFormat(modelValue.coste) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        @keypress.native="$emit('changed')"
        @input="$emit('updated')"
        @keyup.native="calcularDescuentoTotal"
        vMoney
        :format="porcentaje"
        v-model.lazy="modelValue.porcentaje_descuento"
        :id="'porcentajeDescuento' + index"
      >
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.descuento_total')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.descuento_total'][0] }}</strong>
        </span>
      </input-field>
      <span v-else>{{ decimalFormat(modelValue.porcentaje_descuento) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <div v-if="mostrarSelectNombre" class="select2-field">
        <v-select
          @input="inputTarifa"
          v-model.lazy="modelValue.selectedTarifa"
          label="nombre"
          :options="tarifas"
          :id="'iva' + index"
        ></v-select>
        <span
          v-if="errores.hasOwnProperty('detalles.' + index + '.id_iva')"
          class="helper-text text-danger"
          slot="helper"
        >
          <strong>{{ errores['detalles.' + index + '.id_iva'][0] }}</strong>
        </span>
      </div>
      <span v-else>{{ modelValue.selectedTarifa !== null?modelValue.selectedTarifa.nombre:'' }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        readonly
        vMoney
        :format="money"
        :id="'impuestos' + index"
        v-model.lazy="modelValue.total_impuestos"
      ></input-field>
      <span v-else>{{ moneyFormat(modelValue.total_impuestos) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        readonly
        vMoney
        :format="money"
        :id="'impuestos' + index"
        :value="retencion"
      ></input-field>
      <span v-else>{{ moneyFormat(retencion) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        vMoney
        :format="money"
        :id="'total' + index"
        :value="total"
        readonly
      ></input-field>
      <span v-else>{{ moneyFormat(total) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        readonly
        vMoney
        :format="porcentajeNegative"
        :id="'utilidad' + index"
        :value="porcentaje_utilidad"
      ></input-field>
      <span v-else>{{ decimalFormat(porcentaje_utilidad) }}</span>
    </td>
    <td @click="clickSelectNombre">
      <label :id="'mostrarDetalle' + index">
        <input
          type="checkbox"
          :id="'mostrarDetalle' + index"
          v-model.lazy="modelValue.mostrar_detalle"
        />
        <span></span>
      </label>
    </td>
    <td @click="clickSelectNombre">
      <input-field
        v-if="mostrarSelectNombre"
        :id="'observacion' + index"
        v-model.lazy="modelValue.observacion"
      ></input-field>
      <span v-else>{{ modelValue.observacion }}</span>
    </td>
    <td>
      <button @click="$emit('eliminar', index)" class="btn-danger btn--text" type="button">
        <i class="fa fa-trash-o"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  updated: function() {
    let input = document.getElementsByClassName("multiselect__input");
    if (input.length > 0)
      for (let i = 0; i < input.length; i++) input[i].maxLength = 65535;
  },
  mixins: [clickaway],
  props: {
    errores: {
      type: Object,
      required: true
    },
    valorIrbpnr: {
      type: Number,
      required: false,
      default: 0
    },
    index: {
      type: Number,
      required: true,
      default: 0
    },
    retencionServicios: {
      type: Number,
      required: true,
      default: 0
    },
    retencionProductos: {
      type: Number,
      required: true,
      default: 0
    },
    value: {
      type: Object,
      required: false,
      default: function() {
        return {
          id_item: "",
          tipo_item: "P",
          nombre_item: "",
          cantidad: 1,
          precio: 0,
          total_descuento: 0,
          total_impuestos: 0,
          selectedTarifa: null,
          selectedCategoria: null,
          selectedItem: null,
          total_inicial: 0,
          total_parcial: 0,
          irbpnr: false,
          cantidad_irbpnr: 0,
          total_irbpnr: 0,
          porcentaje_iva: 0,
          iva: 0,
          porcentaje_ed_valorem: 0,
          precio_produccion: 0,
          total_parcial_ice: 0,
          porcentaje_ice: 0,
          numero_unidades_ice: 0,
          tarifa_especifica_ice: 0,
          cantidad_ice: 0,
          ice: 0,
          precio_sin_subsidio: 0,
          valor_subsidio: 0,
          id_iva: "",
          id_ice: "",
          total: 0,
          porcentaje_descuento: 0,
          coste: 0,
          observacion: "",
          descripcion: "",
          retencion: 0,
          margen_utilidad: 0
        };
      }
    },
    tarifas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      modelValue: this.value,
      porcentaje_descuento: 0,
      money: money,
      isLoadingCategoria: false,
      listaCategorias: [],
      listaCategoriasTemp: [],
      isLoadingItem: false,
      listaProductos: [],
      listaProductosTemp: [],
      money2: money2,
      decimal: decimal,
      porcentaje: porcentaje,
      moneyNegative: moneyNegative,
      porcentajeNegative: porcentajeNegative,
      mostrarSelectNombre: false,
      moneyFormat: moneyFormat,
      decimalFormat: decimalFormat,
      url: url,
      currentPosition: this.index + 1
    };
  },
  methods: {
    onSearchCategoria: function (search) {
      if (search.length) {
        this.isLoadingCategoria = true;
        this.searchingCategoria(search, this);
      }
    },
    searchingCategoria: _.debounce((search, vm) => {
      fetch(`${url}/categorias/search-categoria?search=${search}`)
        .then((response) => response.json())
        .then((data) => {
          vm.listaCategorias.splice(0, vm.listaCategorias.length, ...data);
          vm.isLoadingCategoria = false;
        });
    }, 350),
    onSearchItem: function (search) {
      if (search.length) {
        this.isLoadingItem = true;
        this.searchingItem(search, this);
      }
    },
    searchingItem: _.debounce((search, vm) => {
      fetch(`${url}/items/search-item?search=${search}`)
        .then((response) => response.json())
        .then((data) => {
          vm.listaProductos.splice(0, vm.listaProductos.length, ...data);
          vm.isLoadingItem = false;
        });
    }, 350),
    cambiarIndice: function() {
      let currentPosition = parseInt(this.currentPosition);
      if (!isNaN(currentPosition) && currentPosition <= this.totalItems) {
        this.$emit("cambiarIndice", currentPosition - 1, this.modelValue);
      } else swal("La posición proporcionada es inválida.", "Aviso", "warning");
    },
    away() {
      if (this.mostrarSelectNombre) {
        this.mostrarSelectNombre = false;
      }
    },
    clickSelectNombre: function() {
      if (!this.mostrarSelectNombre) this.mostrarSelectNombre = true;
      this.$emit("changed");
    },
    inputTarifa: function() {
      if (
        this.modelValue.selectedTarifa !== undefined &&
        this.modelValue.selectedTarifa !== null
      ) {
        this.modelValue.id_iva = this.modelValue.selectedTarifa.id_tarifa;
        this.modelValue.porcentaje_iva = this.modelValue.selectedTarifa.porcentaje;
      } else {
        this.modelValue.id_iva = "";
        this.modelValue.porcentaje_iva = 0;
        this.modelValue.iva = 0;
      }
      this.$emit("updated");
    },
    addTagCategoria: function(newTag) {
      const tag = {
        nombre: newTag,
        id:
          newTag.substring(0, 2).toUpperCase() +
          Math.floor(Math.random() * 10000000)
      };
      this.listaCategoriasTemp.push(tag);
      this.listaCategorias.push(tag);
      this.modelValue.selectedCategoria = tag;
      this.$emit("updated");
    },
    addTagItem: function(newTag) {
      const tag = {
        nombre: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.listaProductosTemp.push(tag);
      this.listaProductos.push(tag);
      this.modelValue.selectedItem = tag;
      this.modelValue.descripcion = tag.nombre;
      this.$emit("updated");
    },
    calcularDescuentoTotal: function() {
      let descuentoTotal =
        this.total_inicial * (this.modelValue.porcentaje_descuento / 100);
      if (descuentoTotal <= this.total_inicial) {
        if (isNaN(descuentoTotal)) descuentoTotal = 0;
      } else {
        this.modelValue.porcentaje_descuento = 0;
        descuentoTotal = 0;
      }
      this.modelValue.total_descuento = round(descuentoTotal);
      this.$emit("updated");
    },
    calcularPorcentajeDescuento: function() {
      let porcentajeDescuento =
        (parseFloat(this.modelValue.total_descuento) / this.total_inicial) *
        100;
      if (porcentajeDescuento <= 100) {
        if (isNaN(porcentajeDescuento)) porcentajeDescuento = 0;
      } else {
        this.modelValue.total_descuento = 0;
        porcentajeDescuento = 0;
      }
      this.modelValue.porcentaje_descuento = round(porcentajeDescuento);
      this.$emit("updated");
    },
    inputItem: function(value) {
      if (value !== undefined && value !== null) {
        let that = this;
        axios.get(this.url + "/items/" + value.id).then(function(response) {
          value = response.data;
          if (value.tipo_item !== undefined && value.tipo_item !== null)
            that.modelValue.tipo_item = value.tipo_item;
          if (value.categoria !== undefined && value.categoria !== null)
            that.modelValue.selectedCategoria = value.categoria;
          if (value.tarifa_iva !== undefined && value.tarifa_iva !== null)
            that.modelValue.selectedTarifa = value.tarifa_iva;
          if (
            value.valor_subsidio !== undefined &&
            value.valor_subsidio !== null
          )
            that.modelValue.valor_subsidio = value.valor_subsidio;
          else that.modelValue.valor_subsidio = 0;
          if (
            value.precio_sin_subsidio !== undefined &&
            value.precio_sin_subsidio !== null
          ) {
            that.modelValue.precio_sin_subsidio = value.precio_sin_subsidio;
            that.modelValue.precio = value.precio_subsidiado;
          } else that.modelValue.precio_sin_subsidio = 0;
          if (
            value.id_tarifa_iva !== undefined &&
            value.id_tarifa_iva !== null
          ) {
            that.modelValue.id_iva = value.id_tarifa_iva;
            that.modelValue.porcentaje_iva = value.tarifa_iva.porcentaje;
          }
          if (value.id_tarifa_ice !== undefined && value.id_tarifa_ice !== null)
            that.modelValue.id_ice = value.id_tarifa_ice;
          if (value.tarifa_ice !== undefined && value.tarifa_ice !== null) {
            that.modelValue.porcentaje_ice = value.tarifa_ice.porcentaje;
            that.modelValue.tarifa_especifica_ice =
              value.tarifa_ice.tarifa_especifica;
            that.modelValue.numero_unidades_ice =
              value.tarifa_ice.numero_unidades;
            that.modelValue.porcentaje_ed_valorem =
              value.tarifa_ice.porcentaje_ed_valorem;
            that.modelValue.cantidad_ice = value.cantidad_ice;
          } else {
            that.modelValue.porcentaje_ice = 0;
            that.modelValue.tarifa_especifica_ice = 0;
            that.modelValue.numero_unidades_ice = 0;
            that.modelValue.porcentaje_ed_valorem = 0;
            that.modelValue.cantidad_ice = 0;
          }
          if (value.descripcion !== undefined && value.descripcion !== null)
            that.modelValue.descripcion = value.descripcion;
          that.modelValue.precio_produccion = value.precio_produccion;
          that.modelValue.cantidad_irbpnr = value.cantidad_irbpnr;
          if (value.costo !== null && value.costo !== undefined)
            that.modelValue.coste = value.costo;
          that.$emit("updated");
        });
      }
    },
    calcularImpuestosTotales: function() {
      let totalImpuestos =
        parseFloat(this.iva) + parseFloat(this.ice) + parseFloat(this.irbpnr);
      this.modelValue.total_impuestos = round(totalImpuestos);
      this.$emit("updated");
    },
    inputCategoria: function() {
      this.$emit("updated");
    }
  },
  computed: {
    retencion: function() {
      let retencion = 0;
      let totalSinImpuestos = parseFloat(this.modelValue.total_parcial);
      if (isNaN(totalSinImpuestos)) totalSinImpuestos = 0;
      if (this.modelValue.tipo_item === "P")
        retencion = round(totalSinImpuestos * (this.retencionProductos / 100));
      else
        retencion = round(totalSinImpuestos * (this.retencionServicios / 100));
      this.modelValue.retencion = retencion;
      return retencion;
    },
    margen_utilidad: function() {
      let precio = parseFloat(this.modelValue.precio);
      let coste = parseFloat(this.modelValue.coste);
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      if (isNaN(precio)) precio = 0;
      if (isNaN(coste)) coste = 0;
      let descuento = parseFloat(this.modelValue.total_descuento);
      if (isNaN(descuento)) descuento = 0;
      let costeTotal = coste * cantidad;
      let precioTotal = precio * cantidad;
      let diferencia = precioTotal - descuento - costeTotal - this.retencion;
      this.modelValue.margen_utilidad = diferencia;
      return diferencia;
    },
    porcentaje_utilidad: function() {
      let porcentaje = 0;
      let precio = parseFloat(this.modelValue.precio);
      let coste = parseFloat(this.modelValue.coste);
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      if (isNaN(precio)) precio = 0;
      if (isNaN(coste)) coste = 0;
      let descuento = parseFloat(this.modelValue.total_descuento);
      if (isNaN(descuento)) descuento = 0;
      let costeTotal = coste * cantidad;
      let precioTotal = precio * cantidad;
      let diferencia = precioTotal - descuento - costeTotal - this.retencion;
      porcentaje = round((diferencia / precioTotal) * 100);
      return porcentaje;
    },
    iva: function() {
      let totalParcial = this.total_parcial;
      let porcentajeIva = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * totalParcial;
      iva = round(iva);
      this.modelValue.iva = iva;
      return iva;
    },
    total: function() {
      let total =
        parseFloat(this.total_parcial) +
        parseFloat(this.iva) +
        parseFloat(this.ice) +
        parseFloat(this.irbpnr);
      total = round(total);
      this.modelValue.total = total;
      return total;
    },
    total_parcial_ice: function() {
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precioVenta = parseFloat(this.modelValue.precio);
      if (isNaN(precioVenta)) precioVenta = 0;
      if (
        this.modelValue.porcentaje_ed_valorem !== null &&
        this.modelValue.precio_produccion !== null
      ) {
        let precioProduccion =
          cantidad * parseFloat(this.modelValue.precio_produccion);
        if (precioProduccion > precioVenta) {
          precioProduccion = round(precioProduccion);
          this.modelValue.total_parcial_ice = precioProduccion;
          return precioProduccion;
        }
      }
      let porcentajeIva = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * precioVenta;
      precioVenta += iva;
      precioVenta = round(precioVenta);
      this.modelValue.total_parcial_ice = precioVenta;
      return precioVenta;
    },
    ice: function() {
      let totalConIva = this.total_parcial_ice;
      let ice = 0;
      if (this.modelValue.porcentaje_ice !== null)
        ice = totalConIva * (parseFloat(this.modelValue.porcentaje_ice) / 100);
      else if (this.modelValue.porcentaje_ed_valorem !== null)
        ice =
          totalConIva *
          (parseFloat(this.modelValue.porcentaje_ed_valorem) / 100);
      if (isNaN(ice)) ice = 0;
      ice = round(ice);
      if (this.modelValue.tarifa_especifica_ice !== null) {
        if (this.modelValue.numero_unidades_ice === null)
          ice +=
            parseFloat(this.modelValue.cantidad) *
            parseFloat(this.modelValue.tarifa_especifica_ice);
        else
          ice +=
            parseInt(
              (parseFloat(this.modelValue.cantidad_ice) *
                parseFloat(this.modelValue.cantidad)) /
                this.modelValue.numero_unidades_ice
            ) * parseFloat(this.modelValue.tarifa_especifica_ice);
      }
      if (isNaN(ice)) ice = 0;
      ice = round(ice);
      this.modelValue.ice = ice;
      return ice;
    },
    irbpnr: function() {
      if (this.modelValue.irbpnr) {
        let cantidad =
          parseFloat(this.modelValue.cantidad) *
          parseFloat(this.modelValue.cantidad_irbpnr);
        if (isNaN(cantidad)) cantidad = 0;
        let irbpnr = cantidad * this.valorIrbpnr;
        irbpnr = round(irbpnr);
        this.modelValue.total_irbpnr = irbpnr;
        return irbpnr;
      } else return 0;
    },
    total_inicial: function() {
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precio = parseFloat(this.modelValue.precio);
      if (isNaN(precio)) precio = 0;
      let totalInicial = cantidad * precio;
      totalInicial = round(totalInicial);
      this.modelValue.total_inicial = totalInicial;
      return totalInicial;
    },
    total_parcial: function() {
      let totalInicial = this.total_inicial;
      let totalDescuento = parseFloat(this.modelValue.total_descuento);
      if (isNaN(totalDescuento)) totalDescuento = 0;
      let totalParcial = totalInicial - totalDescuento;
      totalParcial = round(totalParcial);
      this.modelValue.total_parcial = totalParcial;
      return totalParcial;
    }
  },
  watch: {
    index: function(value) {
      this.currentPosition = value + 1;
    },
    "modelValue.iva": function() {
      this.calcularImpuestosTotales();
    },
    "modelValue.ice": function() {
      this.calcularImpuestosTotales();
    },
    "modelValue.total_irbpnr": function() {
      this.calcularImpuestosTotales();
    }
  },
  mounted: function() {
    if (
      this.modelValue.selectedTarifa === null ||
      this.modelValue.selectedTarifa === undefined
    ) {
      let iva = "4";
      for (let i = 0; i < this.tarifas.length; i++)
        if (iva == this.tarifas[i].id_tarifa) {
          this.modelValue.selectedTarifa = this.tarifas[i];
          this.inputTarifa();
          break;
        }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ItemProforma.vue